import React, { useContext, useEffect, useState } from "react";
import "./css/MenuTab.scss";
import MemberContext from "../../store/Member";
import CommonContext from "../../store/Common";
import IntroMenu from "./IntroMenu";
import AdminMenu from "./AdminMenu";
import Exception from "../../util/exception";
import Path from "./const/path";
import CommonFunc from "./common/index";
import { useLocation } from "react-router-dom";

function readServiceFlag(commonValue, storageKey) {
  if (commonValue != null) return String(commonValue);
  return sessionStorage.getItem(storageKey);
}

/** 기업 유형: 2 = 출연연 */
function isResearchInstituteOrg(commonValue, memberValue) {
  const raw =
    commonValue ??
    memberValue ??
    sessionStorage.getItem("organization_type");
  return String(raw) === "2";
}

function MenuTab({ history }) {
  const { auth, admin, organization_type: memberOrgType } =
    useContext(MemberContext);
  const common = useContext(CommonContext);
  const location = useLocation();
  const isLogin = auth != null;
  const isInvestor = window.$Global.checkAuth("투자자", auth);
  const isInventor = window.$Global.checkAuth("특허회사_발명자만", auth);
  const isAdmin = admin; // 슈퍼 계정인지 판별
  const isAgent = window.$Global.checkAuth("대리인", auth);

  const isStatisticPath = readServiceFlag(
    common.statistics_service,
    "statistics_service"
  );
  const isSimpleStatisticPath = readServiceFlag(
    common.simple_statistics_service,
    "simple_statistics_service"
  );
  const isTransferStatisticPath = readServiceFlag(
    common.transfer_statistics_service,
    "transfer_statistics_service"
  );
  // 연차료관리 메뉴: 명시적 false일 때만 숨김 (미설정 시 표시)
  const isAnnualPayPath = readServiceFlag(
    common.annual_pay_service,
    "annual_pay_service"
  );
  const showInventionReview = isResearchInstituteOrg(
    common.organization_type,
    memberOrgType
  );
  const pathname = history.location.pathname.toString();
  const isIntroPath = Exception.exceptionIntro(pathname);
  const isCalcPath = pathname.indexOf("calc") > -1;
  const isExceptionURL =
    Exception.exceptionRoot(pathname) || (isIntroPath && isLogin) || isCalcPath;

  let activeTab = 0;
  const getActiveTab = (path) => {
    if (!path) return false;
    const currentPath = location.pathname || "";
    if (path.endsWith("/")) {
      return currentPath.startsWith(path);
    }
    return currentPath === path || currentPath.startsWith(`${path}/`);
  };
  const path = Path.buildCompanyMenus({
    hideAnnual: isAnnualPayPath === "false",
    showInventionReview,
    // rank 2(발명자)는 특허통계·심플통계·기술이전관리 비노출
    ...(isInventor
      ? {}
      : {
          statistic: isStatisticPath,
          simple: isSimpleStatisticPath,
          transfer: isTransferStatisticPath,
        }),
  });
  const inventorPath = Path.buildInventorMenus({ showInventionReview });
  const agentPath = Path.buildAgentMenus();
  const adminPath = Path.buildAdminMenus();

  const isIntro = getActiveTab("/intro/");
  const isOpenMarket = getActiveTab("/trade/");
  const isFindx =
    getActiveTab("/taskManage/") ||
    getActiveTab("/docTrade/") ||
    getActiveTab("/exposition/") ||
    getActiveTab("/businessDescription/") ||
    getActiveTab("/govSupport/") ||
    getActiveTab("/consortium/") ||
    getActiveTab("/consultCom/") ||
    getActiveTab("/matchingBiz/") ||
    getActiveTab("/marketInfo/") ||
    getActiveTab("/researchTech/");

  const isGroupWare = getActiveTab("/renewal/");

  // 더 긴 URL 매칭을 우선해 하위 경로(예: /admin/annual/sales) 활성 탭이 맞게 잡힌다
  const findActiveTab = (items) => {
    let bestIdx = -1;
    let bestLen = -1;
    items.forEach((obj, idx) => {
      Object.keys(obj).forEach((key) => {
        if (!key.startsWith("url")) return;
        const url = obj[key];
        if (!url || !getActiveTab(url)) return;
        const len = String(url).length;
        if (len >= bestLen) {
          bestLen = len;
          bestIdx = idx;
        }
      });
    });
    if (bestIdx >= 0) activeTab = bestIdx + 1;
  };

  if (isAdmin) {
    findActiveTab(adminPath);
  } else if (isIntro || !isLogin) {
    findActiveTab(Path.match_intro);
  } else if (isOpenMarket) {
    findActiveTab(Path.match_openMarket);
  } else if (isInventor && isLogin) {
    findActiveTab(inventorPath);
  } else if (isFindx) {
    findActiveTab(Path.match_findx);
  } else if (isGroupWare) {
    findActiveTab(Path.match_groupware);
  } else if (isAgent && isLogin) {
    findActiveTab(agentPath);
  } else {
    findActiveTab(path);
  }
  return (
    <div
      id="MenuTab"
      className={`pc ${isIntroPath ? "true" : ""}`}
      style={{
        borderBottom: "1px solid #f6a310",
      }}
    >
      <div className="wrap">
        {isOpenMarket ? (
          <ul className="service_tab_list">
            {CommonFunc.DrawTab(Path.match_openMarket, activeTab, "bold")}
          </ul>
        ) : isFindx && isLogin ? (
          <ul className="service_tab_list">
            {CommonFunc.DrawTab(Path.match_findx, activeTab, "bold")}
          </ul>
        ) : isGroupWare && isLogin ? (
          <ul className="service_tab_list">
            {CommonFunc.DrawTab(Path.match_groupware, activeTab, "bold")}
          </ul>
        ) : isInventor && isLogin ? (
          <ul className="service_tab_list">
            {CommonFunc.DrawTab(inventorPath, activeTab, "bold")}
          </ul>
        ) : isAgent && isLogin ? (
          <ul className="service_tab_list">
            {CommonFunc.DrawTab(agentPath, activeTab, "bold")}
          </ul>
        ) : !isAdmin &&
          !isInvestor &&
          !isIntroPath &&
          isLogin &&
          !isExceptionURL ? (
          <ul className="service_tab_list">
            {CommonFunc.DrawTab(path, activeTab, "bold")}
          </ul>
        ) : (
          !isAdmin &&
          !isInvestor && (
            <IntroMenu
              activeTab={activeTab}
              auth={auth}
              location={location}
              isExceptionURL={isExceptionURL}
            />
          )
        )}
        {isExceptionURL && isAdmin && (
          <IntroMenu
            activeTab={activeTab}
            auth={auth}
            location={location}
            isExceptionURL={isExceptionURL}
          />
        )}
        {isAdmin && !isExceptionURL && <AdminMenu activeTab={activeTab} />}
      </div>
    </div>
  );
}

export default MenuTab;
